import details from './criacaoOuEdicao/state'

export default {
  namespaced: true,
  modules: {
    details
  }
}
